var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgGoogleFilled = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FBC02D",
  d: "M21.806 10.042H21V10h-9v4h5.651A5.998 5.998 0 0 1 6 12a6 6 0 0 1 6-6c1.53 0 2.921.577 3.98 1.52L18.81 4.69A9.95 9.95 0 0 0 12 2C6.478 2 2 6.478 2 12s4.478 10 10 10 10-4.477 10-10c0-.67-.069-1.325-.195-1.959"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#E53935",
  d: "m3.153 7.346 3.286 2.409A6 6 0 0 1 12 6c1.53 0 2.921.577 3.98 1.52L18.81 4.69A9.95 9.95 0 0 0 12 2a9.99 9.99 0 0 0-8.847 5.346"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#4CAF50",
  d: "M12 22c2.583 0 4.93-.989 6.704-2.596l-3.094-2.62A5.96 5.96 0 0 1 12 18a6 6 0 0 1-5.642-3.973l-3.26 2.512C4.751 19.778 8.112 22 12 22"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#1565C0",
  d: "M21.806 10.042 21.797 10H12v4h5.651a6 6 0 0 1-2.043 2.785h.002l3.095 2.619C18.485 19.602 22 17 22 12c0-.67-.069-1.325-.195-1.959"
})));
export default SvgGoogleFilled;